var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParkOutlinePeopleSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1344_4344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 19.1667C19.0893 19.1667 19.9616 18.9932 20.7755 18.656C21.5894 18.3189 22.3289 17.8248 22.9518 17.2018C23.5748 16.5789 24.0689 15.8394 24.406 15.0255C24.7432 14.2116 24.9167 13.3393 24.9167 12.4583C24.9167 11.5774 24.7432 10.7051 24.406 9.89117C24.0689 9.07727 23.5748 8.33775 22.9518 7.71483C22.3289 7.0919 21.5894 6.59777 20.7755 6.26064C19.9616 5.92352 19.0893 5.75 18.2083 5.75C16.4292 5.75 14.7229 6.45677 13.4648 7.71483C12.2068 8.97288 11.5 10.6792 11.5 12.4583C11.5 14.2375 12.2068 15.9438 13.4648 17.2018C14.7229 18.4599 16.4292 19.1667 18.2083 19.1667Z",
    stroke: "#348BDC",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.875 26.833H18.0167C13.7233 26.833 11.5767 26.833 9.936 27.6687C8.49349 28.4037 7.32068 29.5765 6.58567 31.019C5.75 32.6597 5.75 34.8063 5.75 39.0997V40.2497H25.875",
    stroke: "#348BDC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5674 42.5674L39.7762 37.7781M39.7762 37.7781C40.3382 37.2179 40.7838 36.5507 41.0876 35.8177C41.3914 35.0847 41.5474 34.2989 41.5465 33.5055C41.5468 32.1078 41.0624 30.7532 40.1758 29.6726C39.2893 28.592 38.0555 27.8522 36.6846 27.5792C35.3136 27.3063 33.8905 27.5171 32.6576 28.1757C31.4247 28.8343 30.4584 29.9001 29.9232 31.1913C29.3881 32.4825 29.3172 33.9193 29.7227 35.2569C30.1283 36.5944 30.9851 37.75 32.1472 38.5267C33.3093 39.3035 34.7048 39.6532 36.0959 39.5164C37.487 39.3797 38.7877 38.7663 39.7762 37.7781Z",
    stroke: "#676767",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1344_4344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlinePeopleSearch);
export default __webpack_public_path__ + "static/media/icon-park-outline_people-search.e0f4f49a65b4afde72b205934b93d73c.svg";
export { ForwardRef as ReactComponent };